import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
var qs = require("qs");
var NewsList = /** @class */ (function (_super) {
    tslib_1.__extends(NewsList, _super);
    function NewsList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            news: [],
            page: _this.props.history.location.search.split('=')[1] ? Number(_this.props.history.location.search.split('=')[1]) - 1 : 0,
            pageSize: 20,
            loading: true,
            query: '',
        };
        return _this;
    }
    NewsList.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.history.action === "POP") {
            var prevState = localStorage.getItem("news-state");
            if (prevState) {
                var parsePrevState = JSON.parse(prevState);
                this.setState(tslib_1.__assign({}, parsePrevState, { page: this.props.history.location.search.split('=')[1] }), function () {
                    _this.getNews();
                });
            }
            else {
                this.getNews();
            }
        }
        else {
            this.getNews();
        }
        localStorage.removeItem("news-state");
    };
    NewsList.prototype.componentWillUnmount = function () {
        localStorage.setItem("news-state", JSON.stringify({
            page: this.state.page,
            pageSize: this.state.pageSize,
            query: this.state.query,
        }));
    };
    NewsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.history.action === "POP") {
            this.setState({ page: this.props.history.location.search.split('=')[1] }, function () {
                _this.getNews();
            });
        }
    };
    NewsList.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'Название',
                accessor: 'title',
                sortable: false,
            }, {
                Header: 'Статус',
                sortable: false,
                accessor: 'active',
                Cell: function (props) {
                    return (React.createElement("span", null, props.row._original.active ? 'На сайте' : 'Скрыта'));
                }
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement(Link, { to: '/news/' + props.row._original.id, className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-eye" })),
                        React.createElement("button", { onClick: _this.changeNews.bind(_this, props.row._original.id, props.row._original), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "far " + (!props.row._original.active ? "fa-square" : "fa-check-square") })),
                        React.createElement("button", { onClick: _this.removeNews.bind(_this, props.row._original.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u041D\u043E\u0432\u043E\u0441\u0442\u0438")),
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement(Link, { to: "/news/0", className: "btn btn-primary" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")),
                React.createElement("div", { className: "form-group" },
                    "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u043B\u043E\u0432\u0430\u043C",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "query", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                query: value,
                            }, function () { return _this.getNews(); });
                        }, value: this.state.query, type: "text" }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.news, columns: columns })))));
    };
    NewsList.prototype.getNews = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        searchString += '&query=' + this.state.query;
        axios.get(API_URL + '/news?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                news: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    NewsList.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () {
            _this.getNews();
            _this.addParamToUrl(page + 1);
        });
    };
    NewsList.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getNews(); });
    };
    NewsList.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getNews();
            _this.addParamToUrl(_this.state.page + 1);
        });
    };
    NewsList.prototype.removeNews = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить новость?');
        if (result) {
            axios.delete(API_URL + '/news/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getNews();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    NewsList.prototype.changeNews = function (id, news) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите изменить статус новости?');
        if (result) {
            axios.put(API_URL + '/news/' + id, qs.stringify({ active: !news.active }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getNews();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    NewsList.prototype.addParamToUrl = function (param) {
        var url = '?page=' + param;
        this.props.history.push(url);
        return true;
    };
    return NewsList;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
    isAdmin: state.app.get("is_sadmin"),
}); })(NewsList));



//////////////////
// WEBPACK FOOTER
// ./src/views/news/index.tsx
// module id = 542
// module chunks = 0